import { useDispatch, useSelector } from 'react-redux'
import history from '../../../history'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useMediaQuery } from 'react-responsive'
import { PATH_HELPERS } from '../../../constants/navigation'
import { constructFiltersAndOmitEmpty } from '../../../helpers/listings/filters'
import { deleteSavedSearch } from '../../../actions/savedSearches'
import { selectCustomerId } from '../../../store/selectors/customerProfile'
import { Button, Text } from '../..'
import { ListView } from './ListView/ListView'
import { SavedSearchModel } from '../../../types/savedSearches'

import styles from './SavedSearch.module.scss'

export interface SavedSearchProps {
  savedSearch: SavedSearchModel
}

const SavedSearch = ({ savedSearch }: SavedSearchProps) => {
  const dispatch = useDispatch()
  const customerId = useSelector(selectCustomerId)

  const handleDelete = () => {
    dispatch(deleteSavedSearch(customerId, savedSearch.locationId))
  }

  const loadListings = () =>
    history.push(
      `${PATH_HELPERS.listings.buildPath(
        customerId,
        savedSearch.location.level,
        savedSearch.location.name,
        constructFiltersAndOmitEmpty(savedSearch)
      )}`
    )

  const isMediumScreen = useMediaQuery({
    query: `(min-width: ${styles.mediumBreak})`,
  })

  const intl = useIntl()
  const messages = defineMessages({
    seeMore: {
      id: 'SavedSearch.listing.more.button.reader',
      defaultMessage: ' for {displayName}',
    },
  })

  const displayName = savedSearch?.displayName

  return (
    <div>
      <div className={styles.savedRegionHeader}>
        <Text
          element='h2'
          size={isMediumScreen ? 'xl' : 'm'}
          align='left'
          weight='semibold'
          variant='neutralCool'
          variantCount='900'
        >
          {displayName}
        </Text>
      </div>
      <ListView listings={savedSearch.listings} customerId={customerId} />
      <div className={styles.savedSearchActionsWrapper}>
        <Button danger type='submit' onClick={handleDelete}>
          <FormattedMessage
            id='SavedSearch.listings.delete.button'
            defaultMessage='Delete {displayName}'
            values={{
              displayName,
            }}
          />
        </Button>
        <Button primary style={{ marginLeft: '12px' }} onClick={loadListings}>
          <FormattedMessage
            id='SavedSearch.listings.more.button'
            defaultMessage='See More Results'
          />
          <span className='screenReaderText'>
            {intl.formatMessage(messages.seeMore, { displayName })}
          </span>
        </Button>
      </div>
    </div>
  )
}

export default SavedSearch
